var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Field } from '../Field';
import { Input } from '../Input';
export var FieldText = function (props) {
    var label = props.label, name = props.name, required = props.required, help = props.help, error = props.error, placeholder = props.placeholder, className = props.className, rest = __rest(props, ["label", "name", "required", "help", "error", "placeholder", "className"]);
    return (React.createElement(Field, { className: className, name: name, label: label, required: required, help: help, error: error }, function (renderProps) { return (React.createElement(Input, __assign({ placeholder: placeholder }, renderProps, rest))); }));
};
//# sourceMappingURL=index.js.map